<template>
  <label>
    <input id="navigation-guards-toggle" v-model="disableNavigationGuards" type="checkbox">
    Navigation guards
  </label>
</template>

<script>
export default {
  name: 'NavigationGuardsDevBox',

  computed: {
    disableNavigationGuards: {
      get () {
        return !this.$store.state.Dev.disableNavigationGuards
      },
      set (value) {
        this.setDisableNavigationGuards(!value)
      }
    }
  },

  methods: {
    setDisableNavigationGuards (value) {
      return this.$store.commit('setDisableNavigationGuards', value)
    }
  }
}
</script>
